/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { SortDirection } from '@angular/material/sort';
import { CLIENT_PLAN_TYPES } from '@core/models';
import { ClientTenantTypeEnum, ClientEnvironmentEnum, CompanyTypesEnum, ClientStatusEnum } from '@truckstop-tms/zuum-lib';

export interface ClientSearch {
  searchText: string;
  accountStatus: (ClientStatusEnum | AllOption.All)[];
  cluster: number;
  companyType: (CompanyTypesEnum | AllOption)[] | undefined;
  tenantType: (ClientTenantTypeEnum | AllOption)[] | undefined;
  accountManager: string | undefined;
  environment: ClientEnvironmentEnum | AllOption | undefined;
  packageType: CLIENT_PLAN_TYPES | AllOption | undefined;
  billingType: string | undefined;
  companyId: string;
  paymentMethodStatus?: string;
  from: number;
  size: number;
  orderBy: string;
  orderType: SortDirection;
  fromDate: string;
  toDate: string;
  testAccount?: boolean;
}

export enum AllOption {
  All = 'All',
}
